import axios from "axios";
export default {
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async loadDepartment( _, params){
        return await axios.get('/departments', { params })
        .then(response => {
          return Promise.resolve(response);
        })
        .catch(errors => {
          return Promise.reject(errors.response)
        })
    },
    async createDepartment( _, formData){
      return await axios.post('/departments', formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async updateDepartment( _, {id, formData}){
      return await axios.post(`/departments/${id}`, formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
  }
};
